/**
 * Formats an amount of money for the results screens: always two decimals (#141, WEB-P4-78).
 *
 * The server pays and stores prizes in whole cents since WEB-P4-78, but rows settled before that may
 * hold sub-cent values (MONEY keeps four decimals), and the screens showed them raw: 13.332, 19.998,
 * 6.666. An empty value is shown as "-", not as 0.00, so a missing amount is not mistaken for nothing.
 *
 * @param {*} value A number, or a numeric string, from the API.
 * @returns {string} e.g. "20.00", or "-" when there is no number.
 */
export const formatMoney = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toFixed(2) : "-";
};

const USD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats an amount of money in US dollars (#206): the dollar sign, thousands separators, and the
 * same rules as formatMoney - always two decimals, "-" when there is no number.
 *
 * @param {*} value A number, or a numeric string, from the API.
 * @returns {string} e.g. "$1,000.00", or "-" when there is no number.
 */
export const formatUsd = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const amount = Number(value);
  return Number.isFinite(amount) ? USD.format(amount) : "-";
};

const USD_WHOLE = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/**
 * Formats an amount of money in US dollars without forcing cents (#236, the Auctions list's Total
 * Pool): "$1,240" for a whole amount, "$1,240.50" otherwise, "-" when there is no number.
 *
 * @param {*} value A number, or a numeric string, from the API.
 * @returns {string} e.g. "$1,240", or "-" when there is no number.
 */
export const formatUsdWhole = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const amount = Number(value);
  return Number.isFinite(amount) ? USD_WHOLE.format(amount) : "-";
};
